export const SuccessNotificationsLabels = {
  REPORT_CREATED: 'Report was created successfully',
  REPORT_SENT: 'Report was sent, please check.',
};

export const ErrorNotificationsLabels = {
  GENERAL: 'Something went wrong, please try again later',
};
